import { algoliaCenterSearch } from '@/lib/algoliaCenterSearch'
import { SPONSOR_TIER } from '@/domain/center'
import { Center } from '@/types/models'
import { getPrimaryFocusFilter } from '@/domain/primaryFocus/useCases/getPrimaryFocusFilter'
import { PrimaryFocus } from '@/domain/primaryFocus/constant'
import { isNonEmptyObject, isNonEmptyString, isNumber } from '@/utils/checks'
import { TermData } from '@/domain/destinations/constants'
import {
  baseFilters,
  baseSponsorFilters,
  baseStatusFilters
} from '@/lib/constants'
const getFilterFromTermData = (data: {
  type: string
  title: string
}): string[] => {
  const hasValidTermData =
    isNonEmptyObject(data) &&
    isNonEmptyString(data.type) &&
    isNonEmptyString(data.title)
  if (hasValidTermData) {
    const titleParts = data.title.split(' ')
    const filter =
      titleParts.length > 1
        ? `${data.type}:'${data.title}'`
        : `${data.type}:${data.title}`
    return [filter]
  }
  return []
}

export const fetchFeaturedCenters = async ({
  hitsPerPage,
  primaryFocus,
  location,
  termData,
  aroundRadius,
  aroundPrecision,
  aroundLatLng
}: {
  hitsPerPage: number
  primaryFocus?: PrimaryFocus
  location?: string
  termData?: TermData | TermData[]
  aroundRadius?: number | string
  aroundPrecision?: number | string
  aroundLatLng?: string
}): Promise<Center[]> => {
  try {
    const distanceOptions: {
      aroundRadius?: number | string
      aroundPrecision?: number | string
      aroundLatLng?: string
    } = {}

    if (isNonEmptyString(aroundLatLng)) {
      distanceOptions.aroundLatLng = aroundLatLng
    }
    if (isNonEmptyString(aroundRadius) || isNumber(aroundRadius)) {
      distanceOptions.aroundRadius = aroundRadius
    }
    if (isNonEmptyString(aroundPrecision) || isNumber(aroundPrecision)) {
      distanceOptions.aroundPrecision = aroundPrecision
    }
    let filterOptions: string[] = []
    if (isNonEmptyString(primaryFocus)) {
      filterOptions.push(getPrimaryFocusFilter(primaryFocus))
    }

    if (Array.isArray(termData)) {
      termData.forEach((data) =>
        filterOptions.push(...getFilterFromTermData(data))
      )
    } else if (termData) {
      filterOptions.push(...getFilterFromTermData(termData))
    }

    if (isNonEmptyString(location)) {
      filterOptions.push(`locations:'${location}'`)
    }
    filterOptions = [
      baseSponsorFilters,
      ...baseStatusFilters,
      ...filterOptions
    ].filter(Boolean)

    const { hits } = await algoliaCenterSearch({
      query: '',
      filters: filterOptions,
      hitsPerPage,
      ...distanceOptions
    })

    return hits
  } catch (error) {
    console.error('Error fetching featured centers:', error)
    return []
  }
}
